<form [formGroup]="datosContactoFormGroup">
  <h5>Teléfonos</h5>
  <div class="row">
    <rpe-telefonos-form #telefonosForm [formInput]="formInputTelefono"
      (formStatusChanges)="telefonoFormStatusChange($event)"
      (formValueChanges)="telefonoFormValueChange($event)"></rpe-telefonos-form>
  </div>

  <h5>Correo electrónico</h5>
  <div class="row" formArrayName="correos_electronico" *ngFor="let oc of correos_electronico().controls; index as i">
    <div [formGroupName]="i">
      <mat-form-field class="col">
        <input matInput placeholder="Correo electrónico:" formControlName="direccion" required>
        <mat-error *ngIf="datosContactoFormGroup.get('correos_electronico')?.get(i.toString())?.hasError('required')">
          Debe ingresar un correo electrónico
        </mat-error>
      </mat-form-field>
    </div>
    <div class="col-1" *ngIf="correos_electronico().length > 1">
      <button type="button" class="float-right" mat-icon-button (click)="eliminarUnCorreoElectronico(i)" color="warn"
        [disabled]="correos_electronico().length < 2" matTooltip="Eliminar correo electrónico">
        <mat-icon>
          <fa-icon icon="minus"></fa-icon>
        </mat-icon>
      </button>
    </div>
  </div>
  <div class="row">
    <button type="button" class="float-right" (click)="agregarOtroCorreoElectronico()" mat-icon-button color="primary"
      matTooltip="Agregar nuevo correo electrónico">
      <mat-icon>
        <fa-icon icon="plus"></fa-icon>
      </mat-icon>
    </button>
  </div>
</form>